import { FC } from 'react';
import { Accordion, AccordionItem } from '@carbon/react';
import { CostBucketTable } from './cost-bucket-table';
import {
  formatCurrency,
  type CostBucket,
  type DraftLineItem,
} from './cost-utils';
import styles from './cost.module.scss';

interface Props {
  buckets: CostBucket<DraftLineItem>[];
  /** Ids of the currently-expanded buckets. */
  expandedBuckets: Set<string>;
  /** Toggle the open/closed state of a single bucket. */
  onToggleBucket: (bucketId: string) => void;
}

// ── Read-view bucket accordion (collapsible (category, class) buckets) ──
export const CostBucketAccordion: FC<Props> = ({
  buckets,
  expandedBuckets,
  onToggleBucket,
}) => {
  return (
    <Accordion className={styles.accordion}>
      {buckets.map((bucket) => {
        const isOpen = expandedBuckets.has(bucket.id);
        const title = (
          <span className={styles.bucketTitle}>
            <span className={styles.bucketName}>
              {bucket.name}
              {bucket.classCode && (
                <span className={styles.bucketCode}> ({bucket.classCode})</span>
              )}
            </span>
            <span className={styles.bucketSubtotalInline}>
              — Subtotal: {formatCurrency(bucket.subtotal)}
            </span>
          </span>
        );
        return (
          <AccordionItem
            key={bucket.id}
            open={isOpen}
            onHeadingClick={() => onToggleBucket(bucket.id)}
            title={title}
          >
            <CostBucketTable items={bucket.items} />
            <div className={styles.groupSubtotalRow}>
              <span className={styles.groupSubtotal}>
                Subtotal: {formatCurrency(bucket.subtotal)}
              </span>
            </div>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};
